import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-dialog-unsubscribe-office',
  templateUrl: './dialog-unsubscribe-office.component.html',
  styleUrls: ['./dialog-unsubscribe-office.component.scss'],
})
export class DialogUnsubscribeOfficeComponent {
  //----------Inputs & Outputs----------
  @Output() change: EventEmitter<string> = new EventEmitter<string>();
  @Input() value: any;

  changeDeclineDate(element: any): void {
    const ELEMENT = element.target.value;
    this.value.declineDate = ELEMENT;
    this.value = { ...this.value };
    this.change.emit(this.value.declineDate);
  }
}
